import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import ItemMarketplaceDetails from './ItemMarketplaceDetails';
import ItemRecipient from './ItemRecipient';
import { EditType } from './EditType';
import { SmartSendItemSelect } from '../SmartSendItemSelect';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import ItemContents from './ItemContents';
import { ItemActionType } from './SetMarketplaceAction';
import { P2GLink } from '@parcel2go/core-ui';
import SmartSendItemBookedDrop from './SmartSendItemBookedDrop';
import { EventSections } from '../../../lib/events/EventLogger';
import P2GContentDropDown from '../../P2GContentDropDown';
import { GetExternalTrackingNumber } from '../../../lib/helpers/SmartSendSummaryGenerator';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';
import ItemBookedService from './ItemBookedService';

interface props {
  item: SmartSendItemApiModel;
  toggleSelect: (val: boolean) => void;
  removeTag: (tag: string) => void;
  saveTags: (tags: string[]) => void;
  edit: (type: EditType) => void;
  arrangeReturn?: () => void;
  action: (type: ItemActionType) => void;
  isReturn: boolean;
}

export default function SmartSendItemBooked(props: props) {
  const trackingNumber = GetExternalTrackingNumber(props.item);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const action = (type: ItemActionType) => {
    props.action && props.action(type);
  };

  const viewDetails = () => {
    props.edit && props.edit('SMARTSEND-ORDER-DETAILS');
  };

  const viewActions = () => {
    props.edit && props.edit('SMARTSEND-ORDER-ACTIONS');
  };

  const viewTrackingDetails = () => {
    props.edit && props.edit('SMARTSEND-ORDER-TRACKING');
  };

  const viewLabels = () => {
    props.edit && props.edit('SMARTSEND-ORDER-LABELS');
  };

  return (
    <div>
      <P2GBox p={1}>
        <SmartSendItemSelect selected={!!props.item.State?.selected} toggle={props.toggleSelect}>
          <P2GGrid container spacing={1}>
            <P2GGrid item xs={12} sm={6} md={4} lg={4}>
              <ItemContents edit={viewDetails} item={props.item} revealText={t('VIEW_LINK', 'View')} variant="body2" />
            </P2GGrid>
            <P2GGrid item xs={12} sm={6} md={3} lg={3}>
              <ItemRecipient
                edit={viewDetails}
                customer={props.isReturn ? props.item.Sender : props.item.Recipient}
                revealText={t('VIEW_LINK', 'View')}
                variant="body2"
              />
            </P2GGrid>
            <P2GGrid item sm={12} md={5} lg={5}>
              {props.item.BookingDetails?.Service && (
                <ItemBookedService
                  trackingNumber={trackingNumber}
                  item={props.item}
                  viewTracking={viewTrackingDetails}
                  viewActions={viewActions}
                  viewDetails={viewDetails}
                  variant="body2"
                />
              )}
            </P2GGrid>
          </P2GGrid>
        </SmartSendItemSelect>
      </P2GBox>
      <ItemMarketplaceDetails
        section={EventSections.BookedItems}
        action={action}
        item={props.item}
        removeTag={props.removeTag}
        saveTags={props.saveTags}
        drop={
          <P2GContentDropDown
            control={
              <P2GLink variant="body2">
                <Trans t={t} i18nKey="QUICK_ACTIONS_LINK" defaults="Quick<br />Actions" />
              </P2GLink>
            }
          >
            <SmartSendItemBookedDrop
              viewActions={viewActions}
              viewTracking={viewTrackingDetails}
              viewLabels={viewLabels}
              viewDetails={viewDetails}
              arrangeReturn={props.arrangeReturn}
              direction="column"
            />
          </P2GContentDropDown>
        }
      />
    </div>
  );
}
